import { Component, Input } from '@angular/core';
import { TimeActionItem } from '../../models/results-types';
import { getTimeFromNowInText } from '@shared/utils/date-format.util';

@Component({
  selector: 'time-action-item',
  templateUrl: './time-action-item.component.html',
  styleUrls: ['./time-action-item.component.scss'],
})
export class TimeActionItemComponent {
  timeToDisplay: string;
  private _model: TimeActionItem;

  get model(): TimeActionItem {
    return this._model;
  }

  @Input()
  set model(value: TimeActionItem) {
    if (!value) {
      return;
    }
    this._model = value;
    this.timeToDisplay = getTimeFromNowInText(value.time).toLowerCase();
  }

  onAction() {
    this.model.actionButton.buttonAction();
  }
}
